import React from "react"

export default function Hero() {
  return (
    <section className="hero">
      <div className="container">
        <p className="eyebrow">Freelance Web Developer</p>
        <h1>
          I build and maintain <span>fast, reliable websites</span> for businesses that need a developer they can rely on.
        </h1>
        <p className="hero__intro">
          I help agencies, small businesses and site owners with WordPress, Shopify and ExpressionEngine builds, PHP applications, ongoing website management, and honest technical advice for web projects.
        </p>
        <div className="hero__actions">
          <a href="#contact" className="btn filled lg">Start a project</a>
          <a href="#services" className="btn lg">See services</a>
        </div>
        <div className="hero__meta">
          <div>
            <strong>WordPress</strong>
            <span>Theme development</span>
          </div>
          <div>
            <strong>Shopify</strong>
            <span>Theme development</span>
          </div>
          <div>
            <strong>ExpressionEngine</strong>
            <span>Development &amp; support</span>
          </div>
          <div>
            <strong>PHP</strong>
            <span>Custom applications</span>
          </div>
        </div>
      </div>
    </section>
  )
}